import { combineTokens } from '@utils/css';

const tokens = combineTokens("--iframe-boundary", {
  height: "unset",
  maxWidth: "100%",
  maxHeight: "calc(100% * var(--iframe-boundary--aspect))",
  aspect: 0.5625
});
const boundaryCls = "_uihb4ttfk3";
const aspectCls = "_uihan8i4mi";
const contentCls = "_uihcmfpvk6";

export { aspectCls, boundaryCls, contentCls, tokens };
import "./comp.boundary.style.linaria.module.css";
//# sourceMappingURL=comp.boundary.style.js.map
